import axios from 'axios';
import {getUrlAgreeAndReject} from "../../pages/controlPanel/util/ControlPanelUtil";

export class MoveGuaranteeService {
    getIndevalAccounts(loanId) {
        return axios.get('/appapv/getIndevalAccounts.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: loanId,
            }
        }).then(res => res.data.payload);
    }

    getTitlesInFlow(loanId) {
        return axios.get('/appapv/getTitlesInFlow.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: loanId,
            }
        }).then(res => res.data.payload);
    }

    getGuaranteeInFlow(loanId) {
        return axios.get('/appapv/getGuaranteeInFlow.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: loanId,
            }
        }).then(res => res.data.payload);
    }

    validateExtensionPr(
        loanId,
        maturity,
        status,
        action
    ) {
        return axios.get('/appapv/validateExtensionPr.action', {
            headers: {},
            params: {
                folio: loanId,
                plazo: maturity,
                status: status,
                accionProrroga: action,
            }
        }).then(res => res.data);
    }

    extensionPr(loanId, status, maturity, tasa, sobreTasa, guaranteeList) {
        return axios.get('/appapv/extensionPr.action', {
            headers: {},
            params: {
                folio: loanId,
                status: status,
                plazo: maturity,
                tasa: tasa,
                sobreTasa: sobreTasa,
                listaGarantiasJson: JSON.stringify(guaranteeList),
            }
        }).then(res => res.data);
    }


    setGuaranteePA(loanId, account, status, guaranteeList) {
        return axios.post('/appapv/setGuaranteePA.action', {}, {
            params: {
                folio: loanId,
                cuenta: account,
                status: status,
                listaGarantiasJson: JSON.stringify(guaranteeList),
            }
        }).then(res => res.data);
    }

    setGuaranteeE(loanId, status, guaranteeList) {
        return axios.post('/appapv/setGuaranteeE.action', {}, {
            params: {
                folio: loanId,
                status: status,
                listaGarantiasJson: JSON.stringify(guaranteeList),
            }
        }).then(res => res.data);
    }

    setGuaranteeLl(loanId, status, guaranteeList) {
        return axios.post('/appapv/setGuaranteeLl.action', {}, {
            params: {
                folio: loanId,
                status: status,
                listaGarantiasJson: JSON.stringify(guaranteeList),
            }
        }).then(res => res.data);
    }

    setGuaranteeS(loanId, status, guaranteeList) {
        return axios.post('/appapv/setGuaranteeS.action', {}, {
            params: {
                folio: loanId,
                status: status,
                listaGarantiasJson: JSON.stringify(guaranteeList),
            }
        }).then(res => res.data);
    }

    rejectBorrowerPA(
        loanId,
        message,
        status) {

        return axios.post('/appapv/rejectBorrowerPA.action', {}, {
            params: {
                folio: loanId,
                mensaje: message,
                status: status
            }
        }).then(res => res.data);
    }

    agree(
        loanId,
        flowId,
        folioTitle,
        folioReward,
        message,
        status,
        guaranteeFolioList) {

        let url = getUrlAgreeAndReject(flowId, status, false);

        return axios.post(url, {}, {
            params: {
                folio: loanId,
                folioIndeval: folioTitle,
                folioPremio: folioReward,
                mensaje: message,
                status: status,
                listaGarantiasJson: JSON.stringify(guaranteeFolioList)
            }
        }).then(res => res.data);
    }

    reject(
        loanId,
        flowId,
        message,
        status) {

        let url = getUrlAgreeAndReject(flowId, status, true);

        return axios.post(url, {}, {
            params: {
                folio: loanId,
                mensaje: message,
                status: status
            }
        }).then(res => res.data);
    }
}